import {CONFIG} from '../../symbols';
import log from '../../log';

export function validateActionPayload(host, type, payload, hostVariables) {
	const {[type]: {validate} = {}} = hostVariables[CONFIG].actions;

	if (
		(process.env.NODE_ENV !== 'production' && payload && typeof payload !== 'object') ||
		Array.isArray(payload)
	) {
		log(
			`Expected payload of ${type} to be an Object but found ${payload}. This will result in inconsistent behavior when combined with behavior options or appendToPayload.`,
			{host, origin: 'validateActionPayload'}
		);
	}

	if (typeof validate === 'function') validate(payload, host);
}
